export const messages = {
  en: {
    userLogin: {
      search: {
        title: 'Search Conditions',
        name: 'Please enter staff name',
        tel: 'Please enter phone number',
        startTime: 'Login start time',
        endTime: 'Login end time'
      },
      table: {
        title: 'Login Logs',
        loginId: 'Login ID',
        parentOrgName: 'Company',
        orgName: 'Department',
        userName: 'Name',
        loginTime: 'Login Time',
        userId: 'Staff ID'
      },
      allStores: 'All',
      fetchError: 'Failed to fetch login logs',
      storeFetchError: 'Failed to fetch store list'
    }
  },
  zh: {
    userLogin: {
      search: {
        title: '查询条件',
        name: '请输入员工名称',
        tel: '请输入手机号',
        startTime: '登录开始时间',
        endTime: '登录结束时间'
      },
      table: {
        title: '登录日志',
        loginId: '登录ID',
        parentOrgName: '公司',
        orgName: '部门',
        userName: '名称',
        loginTime: '登录时间',
        userId: '员工ID'
      },
      allStores: '全部',
      fetchError: '获取登录日志失败',
storeFetchError: '获取门店列表失败'
    }
  },
  'zh-TW': {
    userLogin: {
      search: {
        title: '查詢條件',
        name: '請輸入員工名稱',
        tel: '請輸入手機號',
        startTime: '登錄開始時間',
        endTime: '登錄結束時間'
      },
      table: {
        title: '登錄日誌',
        loginId: '登錄ID',
        parentOrgName: '公司',
        orgName: '部門',
        userName: '名稱',
        loginTime: '登錄時間',
        userId: '員工ID'
      },
      allStores: '全部',
      fetchError: '獲取登錄日誌失敗',
      storeFetchError: '獲取門店列表失敗'
    }
  }
}